export default "__VITE_ASSET__qCEEyaqu__"